import { PaymentReason } from '~features/annals/enums/payment';
import { detectIfBannerCtaClicked } from '~features/newsBanner/utils/retention-popup-url-parser';

export const getPaywallReason = (fallback: PaymentReason) => {
	if (detectIfBannerCtaClicked()) {
		return PaymentReason.RetentionPopupCTA;
	}
	return fallback;
};
